import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Form, Input, DatePicker, Select, Radio, Button, message } from "antd";
import { cookies } from "../../utils"
import moment from "moment";
import locale from 'antd/lib/date-picker/locale/zh_CN';
const FormItem = Form.Item;
const Option = Select.Option;
const RadioGroup = Radio.Group;
export class AccountBasicInfo extends Component {
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    Birthday: "",//生日
    province: null,
    city: null,
    local: null,
    address: null,
  }

  componentDidMount() {
    //获取民族数据列表
    this.props.actions.fetchGetNationList();
    //获取省份数据
    this.props.actions.fetchGetProvinceList();
    //获取学历
    this.props.actions.fetchGetHDictionaryList({ Valid: 1, ColumnName: "Education_ID" });
  }
  handleSubmit = e => {
    let stuID = cookies.getCookie('UserKey');
    const { studentBasics } = this.props.common;
    const {
      Name = null,
      Phone = null,
      CardNumber = null,
      Sex = null,
      NowArea_ID = null,
      Education_ID = null,
      Birthday = null,
      Nation = null,
      Email = null,
      QQ = null,
      NowProvince_ID = null,
      NowCity_ID = null,
      NowAddress = null,
    } = studentBasics;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      const info = {
        CardNumber: values.CardNumber || CardNumber,
        Education_ID: values.Education_ID
          ? isNaN(values.Education_ID)
            ? Education_ID
            : values.Education_ID
          : Education_ID,
        Nation: values.Nation
          ? isNaN(values.Nation)
            ? Nation
            : values.Nation
          : Nation,
        Name: values.Name || Name,
        Email: values.Email || Email,
        Sex: values.Sex === '男' ? 1 : values.Sex === '女' ? 0 : Sex,
        Sex_Name: values.Sex,
        Phone: values.Phone || Phone,
        QQ: values.QQ || QQ,
        NowProvince_ID: this.state.province || NowProvince_ID,
        NowCity_ID:
          this.state.city === "" ? null : this.state.city || NowCity_ID,
        NowArea_ID:
          this.state.local === "" ? null : this.state.local || NowArea_ID,
        Birthday: this.state.Birthday || Birthday,
        NowAddress: this.state.address || NowAddress,
        StuID: stuID,
      };
      if (!err) {
        this.props.actions.fetchEditStudent(info).then(res => {
          if (res.SuccessResponse) {
            this.props.actions.fetchStudentBasics({ StuID: stuID });
            message.success('基本资料更新成功');
          }
        })
      }
    })
  }
  updataBirthday = value => {
    if (!value) return;
    const birthdayformat = moment(value._d).format("YYYY-MM-DD");
    this.setState({ Birthday: birthdayformat });
  };
  updataCity = value => {
    if (value === this.state.province) return; //选相同的
    this.setState({ province: value }, () => {
      this.props.actions.fetchGetCitys({ ID: value });
    });
  }
  updataDistric = value => {
    if (value === this.state.city) return; //选相同的
    this.setState({ city: value }, () => {
      this.props.actions.fetchGetDistricts({ ID: value });
    })
  }
  updataLast = value => {
    if (value === this.state.local) return; //选相同的
    this.setState({ local: value });
  }
  updataAddress = e => {
    let value = e.target.value;
    if (value == null) return;
    this.setState({ address: value });
  }
  render() {
    const { studentBasics } = this.props.common;
    const { getFieldDecorator } = this.props.form;
    const {
      fetchGetNationListSuccess,
      fetchGetProvinceListSuccess,
      fetchGetHDictionaryListSuccess,
      fetchGetDistrictsSuccess,
      fetchGetCitysSuccess,
    } = this.props.center;

    if (JSON.stringify(studentBasics) === "{}") return null;
    let {
      Name,
      CardNumber,
      Birthday,
      Nation_Name,
      Sex,
      Phone,
      Email,
      QQ,
      Education_ID_Name,
      NowProvince_ID_Name,
      NowCity_ID_Name,
      NowArea_ID_Name,
      NowAddress,
    } = studentBasics;
    let nationList = fetchGetNationListSuccess;
    let dictionaryList = fetchGetHDictionaryListSuccess;
    let provinceListOver = fetchGetProvinceListSuccess;
    let cityListOver = fetchGetCitysSuccess;
    let districListOver = fetchGetDistrictsSuccess;
    let Sex_Name = Sex === 0 ? "女" : "男";
    const optionsListNation =
      nationList &&
      nationList.length > 0 &&
      nationList.map(node => (
        <Option key={node.ID} value={node.ID.toString()}>
          {node.Name}
        </Option>
      ));
    const optionsList =
      dictionaryList &&
      dictionaryList.length > 0 &&
      dictionaryList.map(node => (
        <Option key={node.ID} value={node.ID.toString()}>
          {node.Description}
        </Option>
      ));
    const optionsListProvince =
      provinceListOver &&
      provinceListOver.length > 0 &&
      provinceListOver.map(node => (
        <Option key={node.ProvinceID} value={node.ProvinceID.toString()}>
          {node.ProvinceName}
        </Option>
      ));
    const optionsListCity =
      cityListOver &&
      cityListOver.length > 0 &&
      cityListOver.map(node => (
        <Option key={node.CityID} value={node.CityID.toString()}>
          {node.CityName}
        </Option>
      ));
    const optionsListDistric =
      districListOver &&
      districListOver.length > 0 &&
      districListOver.map(node => (
        <Option key={node.DistrictID} value={node.DistrictID.toString()}>
          {node.DistrictName}
        </Option>
      ));
    return (
      <div className="center-account-basic-info">
        <Form onSubmit={this.handleSubmit.bind(this)}>
          <FormItem
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 8 }}
            label="姓名/昵称"
          >
            {getFieldDecorator('Name', {
              initialValue: Name || "",
              rules: [{
                pattern: "^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$", message: "请输入正确的姓名/昵称格式"
              }]
            })(
              <Input
                style={{ width: 300 }}
                placeholder="请输入姓名/昵称"
              />
            )}
          </FormItem>
          <FormItem
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 8 }}
            label="身份证号"
          >
            {getFieldDecorator('CardNumber', {
              initialValue: CardNumber.length > 17 ? CardNumber : "",
              rules: [
                { pattern: "^[1-9]{1}[0-9]{14}$|^[1-9]{1}[0-9]{16}([0-9]|[xX])$", message: "请输入正确的身份证号" }
              ]
            })(
              <Input
                style={{ width: 300 }}
                placeholder="请输入身份证"
              />
            )}
          </FormItem>
          <FormItem
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 8 }}
            label="生日"
          >
            {getFieldDecorator('Birthday', {
              initialValue: Birthday ? moment(Birthday) : ""
            })(
              <DatePicker
                style={{ width: 300 }}
                locale={locale}
                onChange={this.updataBirthday}
              />
            )}
          </FormItem>
          <FormItem
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 8 }}
            label="民族">
            {getFieldDecorator("Nation", {
              initialValue: Nation_Name || "未选择"
            })(
              <Select style={{ width: 300 }} dropdownClassName="form-select">
                {optionsListNation}
              </Select>
            )}
          </FormItem>
          <FormItem
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 8 }}
            label="性别">
            {getFieldDecorator("Sex", {
              initialValue: Sex_Name
            })(
              <RadioGroup style={{ marginLeft: "18px" }}>
                <Radio value="男">男</Radio>
                <Radio value="女">女</Radio>
              </RadioGroup>
            )}
          </FormItem>
          <div className="sperator"></div>
          <FormItem
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 8 }}
            label="手机号">
            {getFieldDecorator("Phone", {
              initialValue: Phone
            })(
              <div>
                <span className="phoneTxt">{Phone}</span>
                <span className="changePhone" onClick={() => {
                  typeof this.props.tabToPhone === "function" && this.props.tabToPhone();
                }}>更换手机号>></span>
              </div>
            )}
          </FormItem>
          <FormItem
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 8 }}
            label="邮箱"
          >
            {getFieldDecorator("Email", {
              initialValue: Email,
              rules: [
                // \. ==> \\.
                { pattern: '^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$', message: '请输入正确的邮箱格式' },
              ]
            })(
              <Input
                placeholder="请输入邮箱"
                style={{ width: 300, }}
              />
            )}
          </FormItem>
          <FormItem
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 8 }}
            label="QQ号码"
          >
            {getFieldDecorator("QQ", {
              initialValue: QQ,
              rules: [
                { pattern: '^[1-9][0-9]{4,10}$', message: '请输入正确的QQ格式', },
              ]
            })(
              <Input
                placeholder="请输入QQ号码"
                style={{ width: 300, }}
              />
            )}
          </FormItem>
          <div className="sperator"></div>
          <FormItem
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 8 }}
            label="学历" >
            {getFieldDecorator("Education_ID", {
              initialValue: Education_ID_Name || "未选择"
            })(
              <Select style={{ width: 300, }} dropdownClassName="form-select">
                {optionsList}
              </Select>
            )}
          </FormItem>
          <FormItem
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
            className="address"
            label="地址">
            <Select
              style={{ width: "110px", }}
              onChange={this.updataCity}
              dropdownClassName="form-select"
              defaultValue={NowProvince_ID_Name || "未选择"}
            >
              {optionsListProvince}
            </Select>
            <Select
              style={{ width: "110px", marginLeft: 5 }}
              onChange={this.updataDistric}
              defaultValue={NowCity_ID_Name || "未选择"}
              dropdownClassName="form-select"
            >
              {optionsListCity}
            </Select>
            <Select
              style={{ width: "110px", marginLeft: 5 }}
              onChange={this.updataLast}
              defaultValue={NowArea_ID_Name || "未选择"}
              dropdownClassName="form-select"
            >
              {optionsListDistric}
            </Select>
            <Input
              defaultValue={NowAddress}
              placeholder="请输入详细地址"
              onChange={this.updataAddress}
              style={{ width: 480, marginLeft: 5, }}
            />
          </FormItem>
          <FormItem
            wrapperCol={{ span: 4, offset: 20 }}
          >
            <Button
              type="theme"
              htmlType="submit"
              className="submitBtn"
            >
              保存修改
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(AccountBasicInfo));



// WEBPACK FOOTER //
// ./src/features/center/AccountBasicInfo.js